//src/components/ui/Checkbox.tsx
import React, { InputHTMLAttributes } from "react";

export interface CheckboxProps extends InputHTMLAttributes<HTMLInputElement> {
    error?: string | null;
    label?: React.ReactNode;
    className?: string;
}

export default function Checkbox({
    id,
    name,
    checked,
    onChange,
    error,
    label = "",
    className = "",
    ...rest
}: CheckboxProps) {
    const baseCheckboxClasses =
        "peer h-5 w-5 shrink-0 cursor-pointer appearance-none rounded-md border border-[#d9d9d9] bg-white checked:bg-black checked:border-black transition-all";
    const finalCheckboxClasses = `${baseCheckboxClasses} ${className}`.trim();

    return (
        <div className="flex items-center">
            <div>
                <label htmlFor={id} className="flex w-full cursor-pointer items-center">
                    <div className="inline-flex items-start">
                        <label className="relative flex cursor-pointer items-center mt-0.5" htmlFor={id}>
                            <input
                                type="checkbox"
                                id={id}
                                name={name}
                                checked={checked}
                                onChange={onChange}
                                className={finalCheckboxClasses}
                                {...rest}
                            />
                            <span className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-white opacity-0 peer-checked:opacity-100">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    className="h-3.5 w-3.5"
                                    viewBox="0 0 20 20"
                                    fill="currentColor"
                                    stroke="currentColor"
                                    strokeWidth="1"
                                >
                                    <path
                                        fillRule="evenodd"
                                        d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                        clipRule="evenodd"
                                    />
                                </svg>
                            </span>
                        </label>
                        <label className="ml-2 cursor-pointer" htmlFor={id}>
                            {label}
                        </label>
                    </div>
                </label>
                {error && <p className="mt-1 text-red-500">{error}</p>}
            </div>
        </div>
    );
}

